///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { GtthAbstractCommand } from '../../abstract-command';
import { GtthCreateLinkCommand } from './create-link-command';
import { ActivityDTO } from '../../../../../services/project-socket/activity-dto.model';
import { GtthPreloaderModalEvent } from '../../../../../shared/preloader-modal/preloader-modal-event';
import { GtthRemoveMultipleEntitiesCommand } from '../remove-multiple-entities-command';
import { GtthLinkFeatureDtoModel } from '../../../../../services/project-socket/dto/gtth-link-feature-dto.model';
import { TopologyLinkTypeEnum } from '../../../../../services/project-socket/dto/topology-types.model';

export class GtthCreateLosesToStationNeighborsCommand extends GtthAbstractCommand {
    private addedLoses: GtthLinkFeatureDtoModel[];
    private addedLosesIds: number[];
    private stationId: number;

    getCommandName(): string {
        return 'GtthCreateLosesToStationNeighborsCommand';
    }

    create(stationId: number): this {
        this.stationId = stationId;
        return this;
    }

    doCommand(): void {
        this.historyService.eventManager.broadcast({
            name: 'togglePreloaderModal',
            eventObject: GtthPreloaderModalEvent.show('Loading')
        });

        this.addedLoses = [];

        const visibleTerminals = this.historyService.logicalTopology.getAllowStationsForLoses(this.stationId);
        visibleTerminals.forEach((losStationId: number) => {
            this.addedLoses.push(
                GtthLinkFeatureDtoModel.fromStationsIds(this.stationId, losStationId, TopologyLinkTypeEnum.NOT_CONFIRMED_LOS)
            );
        });

        const activity = this.createActivityDTO(false);
        activity.links = [...this.addedLoses];
        this.sendActivity(activity);
    }

    undoCommand(): void {
        const removeCommand = this.historyService.command(GtthRemoveMultipleEntitiesCommand).create([], this.addedLosesIds);
        this.historyService.doCommandBypassHistory(removeCommand).then((result: boolean) => {
            this.commandResolve(result);
        });
    }

    doCommandActivity(activityDto: ActivityDTO): void {
        if (!activityDto.successful) {
            if (this.addedLoses) {
                this.historyService.notificationService.showError(activityDto?.error?.message);
            }

            this.commandEnd(activityDto.successful);
        } else {
            const commandsList = [];
            this.addedLosesIds = [];
            activityDto.links.forEach((linkJson) => {
                this.addedLosesIds.push(linkJson.getId());
                const createLinkCmd = this.historyService.command(GtthCreateLinkCommand).createFromGeoJson(linkJson);
                commandsList.push(this.historyService.doCommandBypassHistory(createLinkCmd, true));
            });

            Promise.all(commandsList).then((_res) => {
                this.commandEnd(activityDto.successful);
            });
        }
    }

    isDisabledInReadOnlyMode(): boolean {
        return true;
    }

    isModifyTopology(): boolean {
        return true;
    }

    isClearDesign(): boolean {
        return true;
    }

    private commandEnd(isSuccessful: boolean) {
        this.historyService.eventManager.broadcast({
            name: 'togglePreloaderModal',
            eventObject: GtthPreloaderModalEvent.hide()
        });

        if (this.commandResolve) {
            this.commandResolve(isSuccessful);
        }
    }
}
